import { render, staticRenderFns } from "./AiInterviewProfileCard.vue?vue&type=template&id=f1892028&scoped=true"
import script from "./AiInterviewProfileCard.vue?vue&type=script&lang=ts"
export * from "./AiInterviewProfileCard.vue?vue&type=script&lang=ts"
import style0 from "./AiInterviewProfileCard.vue?vue&type=style&index=0&id=f1892028&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1892028",
  null
  
)

export default component.exports